module.exports = __webpack_public_path__ + "img/section1Logo.1dd1e020.png";